<template>
    <div class="report">
        <h3>Dashboard Kinerja</h3>
        <div class="dashboard-main">
            <div class="top">
                <div class="info">
                    <h5>Tiket Closed</h5>
                    <h2>{{ info.close_tiket }}</h2>
                </div>
                <div class="info">
                    <h5>Jumlah Respon</h5>
                    <h2>{{ info.response_rate }}</h2>
                </div>
                <div class="info">
                    <h5>Rata-Rata Waktu Respon</h5>
                    <h2>{{ info.avg_response_time }}</h2>
                </div>
                <div class="info">
                    <h5>Durasi Aktif</h5>
                    <h2>{{ info.durasi_aktif }}</h2>
                </div>
            </div>
            <div class="mid">
                <div class="perform">
                    <div class="perform-top">
                        <h5>Tiket Perbulan Tahun 2025</h5>
                        <div class="btns-pilih">
                            <button class="btn-act">Perbulan</button>
                            <button>Pertahun</button>
                        </div>
                    </div>
                    <ChartPerform :parseData="tiketSetahun" />
                </div>
                <div class="perform-cate">
                    <ChartPerformCate :parseData="topCat" />
                </div>
            </div>
            <div class="bot"></div>
        </div>
    </div>
</template>
<style scoped>
h1,
h2,
h3,
h4,
h5 {
    font-family: poppins-reg !important;
}

.report {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 20px 20px 20px;
    background-color: white;
    display: grid;
    overflow: auto;
    grid-template-rows: max-content auto;

    .dashboard-main {
        background-color: transparent;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        width: 100%;
        display: grid;
        grid-template-rows: max-content auto max-content;

        .top {
            background-color: transparent;
            height: 200px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;

            .info {
                margin: auto;
                margin-left: 0;
                border: 1px solid #f2f2f2;
                padding: 20px;
                border-radius: 25px;
                box-sizing: border-box;
                height: 90%;
                width: 100%;
                background-color: white;

                h2{
                    text-align: center;
                    margin-top: 40px;
                }
            }
        }

        .mid {
            width: 100%;
            background-color: transparent;
            display: grid;
            grid-template-columns: 60% 40%;

            .perform {
                width: 100%;
                border: 1px solid #f2f2f2;
                height: 100%;
                display: grid;
                grid-template-rows: max-content auto;
                background-color:transparent ;
                border-radius: 30px;
                box-sizing: border-box;
                padding: 20px;
                

                .perform-top {
                    display: grid;
                    grid-template-columns: auto max-content;
                    padding-bottom: 20px;

                    .btns-pilih {
                        background-color: #f2f2f2;
                        padding: 3px 5px;
                        border-radius: 30px;

                        button {
                            font-family: poppins-reg;
                            padding: 4px 7px;
                            font-size: 9pt;
                            border-radius: 30px;
                            border: none;
                        }

                        .btn-act {
                            background-color: #1869ff;
                            color: white;
                        }
                    }
                }

                #chart {
                    background-color: white;
                    height: 100%;
                }
            }

            .perform-cate {
                background-color: transparent;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%t;

                #chart2 {
                    width: 100%;
                    height: 100%;
                    background-color: transparent;

                    .list-cate{
                        background-color: transparent;
                    }
                }

            }
        }

        .bot {
            background-color: rgb(229, 127, 255);
            height: 300px;
        }
    }
}
</style>

<script>
import axios from "axios"
import { backend as be } from "@/assets/config/server.js"
import ChartPerform from "./comp/ChartPerform.vue"
import ChartPerformCate from "./comp/ChartPerformCate.vue"
import { getCookie } from "@/assets/config/cookie"


export default {
    name: "DashboardReport",
    components: {
        ChartPerform,
        ChartPerformCate
    },
    data() {
        return {
            show: true,
            info:{
                avg_response_time : null,
                close_tiket : null,
                durasi_aktif : null,
                response_rate : null
            },
			sessionToken : null,
            tiketSetahun : [],
            topCat : {
                label : [],
                jumlah : []
            },
            loginInfo : null,
        }
    },
    updated() {

    },
    mounted() {
        const data = JSON.parse(getCookie('loginInfo'));
        this.loginInfo = data
		this.sessionToken = this.loginInfo.token;
        console.log(this.sessionToken)
        this.getApi("api/kinerja-petugas-agent")
    },
    methods: {
        async getApi(api, parameter = {}) {
            try {
                const res = await axios.get(
                    `${be}/${api}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${this.sessionToken}`,
                        },
                    },
                    parameter
                );

                this.info = res.data.data
                this.tiketSetahun = this.info.tiket_setahun
                
                for (const el of this.info.top_cat) {
                    this.topCat.label.push(el.name)
                    this.topCat.jumlah.push(el.jum)
                }

                console.log(this.info)
            } catch (err) {
                console.error(err)
                //console.log(sessionToken)
            }
        },
        async postApi(api, datapost = {}) {
            try {
                const res = await axios.post(
                    `${be}/${api}`,
                    datapost,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${this.sessionToken}`,
                        },
                    }
                );

                console.log(res)
            } catch (err) {
                console.error("Error:", err.response?.data || err.message);
            }
        }
    }
}
</script>